<div class="flex flex-col gap-2">
  <label class="text-[12px] font-semibold text-gray-700">
    {{ label() }}
  </label>

  <div class="flex items-center gap-3">
    <input
      type="number"
      [placeholder]="minPlaceholder()"
      [(ngModel)]="minVal"
      class="w-full rounded-md border border-gray-400 px-3 py-2 text-sm outline-none focus:border-black" />

    <span class="text-sm text-gray-500">-</span>

    <input
      type="number"
      [placeholder]="maxPlaceholder()"
      [(ngModel)]="maxVal"
      class="w-full rounded-md border border-gray-400 px-3 py-2 text-sm outline-none focus:border-black" />
  </div>
</div>
